// Add these imports at the top if not already present
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "../css/Homepage.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { toast } from "react-hot-toast";
import useAuthStore from "../store/useAuthStore";
import useFindBuilderStore from "../store/useFindBuilderStore";
import { useNavigate, useLocation } from "react-router-dom";
import Footerlanding from "../components/Footerlanding";

const Homepage = () => {
  const [fontSize, setFontSize] = useState(
    window.innerWidth < 768 ? "30px" : "55px"
  );
  const navigate = useNavigate();
  const location = useLocation();
  const { token, userType } = useAuthStore();
  const {
    states,
    districts,
    taluks,
    fetchLocationData,
    setSelectedState,
    setSelectedDistrict,
    setSelectedTaluk,
  } = useFindBuilderStore();
 // Add these new state variables for the fixed mobile dropdowns
const [fixedMobileJoinDropdown, setFixedMobileJoinDropdown] = useState(false);
const [fixedMobileLoginDropdown, setFixedMobileLoginDropdown] = useState(false);
  const [isBlinking, setIsBlinking] = useState(true);
  const [selectedState, setLocalState] = useState("Tamil Nadu");
  const [selectedDistrict, setLocalDistrict] = useState("");
  const [selectedTaluk, setLocalTaluk] = useState("");
  const [mobileJoinDropdown, setMobileJoinDropdown] = useState(false);
  const [mobileLoginDropdown, setMobileLoginDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const [showFixedNav, setShowFixedNav] = useState(false);

  const handleFind = () => {
    setSelectedState(selectedState);
    setSelectedDistrict(selectedDistrict);
    setSelectedTaluk(selectedTaluk);
    setIsOpen(false);
    navigate("/builderslist");
  };

  const dropdownRef = useRef(null);
  const loginDropdownRef = useRef(null);

 

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close desktop dropdowns
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (loginDropdownRef.current && !loginDropdownRef.current.contains(event.target)) {
        setLoginDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const servicesSection = document.querySelector("#services");
      const nextSection = document.querySelector(".py-3.flex.justify-center");
      if (nextSection) {
        const nextSectionTop = nextSection.getBoundingClientRect().top;
        // Show fixed navbar when next section is at or above viewport top
        setShowFixedNav(nextSectionTop <= 0);
      }
    };  
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (loginDropdownRef.current && !loginDropdownRef.current.contains(event.target)) {
        setLoginDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
    setLoginDropdownOpen(false);
  };

  const loginToggle = () => {
    setLoginDropdownOpen((prev) => !prev);
    setIsDropdownOpen(false);
  };

  const handleLoginRedirect = (selectedUserType) => {
    if (token && userType) {
      if (userType !== selectedUserType) {
        toast.error(`You are already logged in as a ${userType}`);
        return;
      }
      
      if (userType === "builder") {
        navigate("/builder/dashboard");
      } else {
        navigate("/customer/projectinvite");
      }
    } else {
      navigate(`/login?type=${selectedUserType}`);
    }
    
    setIsDropdownOpen(false);
    setLoginDropdownOpen(false);
  };


  useEffect(() => {
    // Check if redirected from login/signup & auto-open the modal
    if (location.state?.fromAuth && token && userType === "customer") {
      setIsOpen(true);
    }
    if (userType === "customer") {
      fetchLocationData();
    }
  }, [location, token, userType, fetchLocationData]);

  const handleFindBuilderClick = () => {
    const user = useAuthStore.getState().user; // Check if user is logged in

    if (!user) {
      localStorage.setItem("redirectAfterLogin", "/"); // Store correct path
      toast.error(
        "Please log in to continue with the builder selection process."
      );
      navigate("/customer/signup"); // Redirect to signup
    } else {
      setIsOpen(true); // Open builder selection modal
    }
  };
  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setIsBlinking(prev => !prev);
    }, 800); // Toggle every 800ms
    
    return () => clearInterval(blinkInterval);
  }, []);

  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      id: 1,
      src: "/assets/Ducktail-latest-project.jpg",
      colSpan: "md:col-span-2", // First photo spans 2 columns
    },
    {
      id: 2,
      src: "/assets/Ducktail-Latest-project-3.jpg",
      colSpan: "md:col-span-1", // Second photo spans 1 column
    },
    {
      id: 3,
      src: "/assets/Ducktail-Latest-project-2.jpg",
      colSpan: "md:col-span-1", // Third photo spans 1 column
    },
  ];

  const testimonials = [
    {
      text: "Now it’s easy to find nearby qualified builders with a 10-year warranty through Ducktail. I personally appreciate the Ducktail support team for their commitment.It’s really a big help for people like us.",
      name: "Abdul Rahman",
      role: "School teacher",
      rating: 5,
    },
    {
      text: " I learned about Ducktail during its trial phase, even before it officially launched. At first, I had doubts since it was a new platform, but I decided to try it for my house construction. ",
      name: "Kishaly ",
      role: "Psychologist",
      rating: 5,
    },
    {
      text: "When I built my home, there was no Ducktail construction platform. That level of support just isn’t possible with other builders.",
      name: "Dr. Vijay Kandeepan ",
      role: "Psychologist",
      rating: 5,
    },
    {
      text: "When I built my home, there was no Ducktail construction platform. I had to rely on a local builder who offered no accountability or clear communication. The process was stressful, with delays and unexpected costs. .",
      name: "Dr. Vijay Kandeepan ",
      role: "Psychologist",
      rating: 5,
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setFontSize(window.innerWidth < 768 ? "30px" : "55px");
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      {/* <div className="fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-black bg-opacity-50" style={{zIndex: 9999}}>
        <div className="max-w-4xl w-full text-center relative">
          <img 
            src="/assets/coming Soon.png" 
            alt="Coming Soon" 
            className="w-full h-auto mx-auto"
          />
          <button 
            className={`
              absolute bottom-20 right-4 
              bg-blue-600 hover:bg-blue-700
              text-white font-medium
              px-4 py-2 rounded-lg
              shadow-[0_4px_9px_-4px_#3b71ca]
              hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]
              active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]
              transform hover:scale-105 active:scale-95
              flex items-center justify-center
              cursor-pointer
              transition-all duration-300 ease-in-out
            `}
            style={{ 
              width: '130px',
              height: '30px',
              fontSize: '12px'
            }}
            onClick={() => navigate('/builder/signup')}
          >
            <span className="animate-pulse">REGISTER NOW</span>
          </button>
        </div>
      </div> */}


{/* Fixed Navbar - Shows when scrolled to services */}
{showFixedNav && (
  <div className="fixed top-0 left-0 right-0 bg-white shadow-md" style={{zIndex: 9998}}>
    <div className="max-w-[90rem] mx-auto px-2 py-3 sm:px-4 lg:px-6">
      <div className="flex justify-between items-center h-16">
        {/* Logo (Black version) */}
        <div className="flex-shrink-0 cursor-pointer" onClick={() => navigate("/")}>
          <img
            src="/assets/white background.jpg"
            alt="Ducktail"
            className="h-12 sm:h-12" 
          />
        </div>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex space-x-3 items-center">
          <a
            href=" "
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
            }}
            className={`relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100 text-black`}
          >
            HOME
          </a>
          <a
            href="#services"
            onClick={(e) => {
              e.preventDefault();
              const servicesSection = document.querySelector("#services");
              if (servicesSection) {
                const yOffset = servicesSection.getBoundingClientRect().top + window.pageYOffset - 100;
                window.scrollTo({ top: yOffset, behavior: 'smooth' });
              }
            }}
            className={`relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100 text-black`}
          >
            SERVICES
          </a>
          
          {/* JOIN US Dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={toggleDropdown}
              className="relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100 text-black"
            >
              JOIN US
            </button>
            {isDropdownOpen && (
              <div className="absolute left-0 mt-2 bg-gray-100 rounded shadow-lg">
                <button
                  onClick={() => handleLoginRedirect("builder")}
                  className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                >
                  Builder
                </button>
                <button
                  onClick={() => handleLoginRedirect("customer")}
                  className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                >
                  Customer
                </button>
              </div>
            )}
          </div>
          
          {/* <a
            href=" "
            className="relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100 text-black"
          >
            JOB PORTAL
          </a> */}
          <a
            href=" "
            onClick={(e) => {
              e.preventDefault();
              navigate("/support");
            }}
            className="relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100 text-black"
          >
            SUPPORT
          </a>
          <div className="hidden lg:block" ref={loginDropdownRef}>
            <button
              onClick={loginToggle}
              className="bg-blue-600 text-white font-bold px-6 py-2 rounded-full hover:bg-blue-700"
              style={{ marginLeft: "60px" }}
            >
              Login 
            </button>
            {loginDropdownOpen && (
              <div className="absolute mt-2 bg-gray-100 rounded shadow-lg">
                <button
                  onClick={() => handleLoginRedirect("builder")}
                  className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                >
                  Builder
                </button>
                <button
                  onClick={() => handleLoginRedirect("customer")}
                  className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                >
                  Customer
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Mobile Menu Button */}
        <div className="lg:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-black p-2 focus:outline-none"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-white rounded-lg mt-2 shadow-lg">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a
              href=" "
              onClick={(e) => {
                e.preventDefault();
                navigate("/");
                setIsOpen(false);
              }}
              className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
            >
              HOME
            </a>
            <a
              href="#services"
              onClick={(e) => {
                e.preventDefault();
                const servicesSection = document.querySelector("#services");
                if (servicesSection) {
                  const yOffset = servicesSection.getBoundingClientRect().top + window.pageYOffset - 100;
                  window.scrollTo({ top: yOffset, behavior: 'smooth' });
                }
                setIsOpen(false);
              }}
              className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
            >
              SERVICES
            </a>
            
            {/* Fixed JOIN US Mobile Dropdown with separate state */}
            <div className="relative">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setFixedMobileJoinDropdown(!fixedMobileJoinDropdown);
                  setFixedMobileLoginDropdown(false);
                }}
                className="flex justify-between items-center w-full px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
              >
                JOIN US
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {fixedMobileJoinDropdown && (
                <div className="pl-4">
                  <button
                    onClick={() => handleLoginRedirect("builder")}
                    className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                  >
                    Builder
                  </button>
                  <button
                    onClick={() => handleLoginRedirect("customer")}
                    className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                  >
                    Customer
                  </button>
                </div>
              )}
            </div>
            
            {/* <a
              href=" "
              className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
            >
              JOB PORTAL
            </a> */}
            <a
              href=" "
              onClick={(e) => {
                e.preventDefault();
                navigate("/support");
                setIsOpen(false);
              }}
              className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
            >
              SUPPORT
            </a>
            
            {/* Fixed LOGIN Mobile Dropdown with separate state */}
            <div className="relative">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setFixedMobileLoginDropdown(!fixedMobileLoginDropdown);
                  setFixedMobileJoinDropdown(false);
                }}
                className="flex justify-between items-center w-full px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
              >
                LOGIN
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {fixedMobileLoginDropdown && (
                <div className="pl-4">
                  <button
                    onClick={() => handleLoginRedirect("builder")}
                    className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                  >
                    Builder
                  </button>
                  <button
                    onClick={() => handleLoginRedirect("customer")}
                    className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                  >
                    Customer
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
)}
    <div>
    {/* Banner Section with Navbar Overlay */}
    <div className="relative w-full">
    <div className="absolute top-0 left-0 right-0 z-30">
      <div className="bg-transparent">
        <div className="max-w-[90rem] mx-auto px-2 py-3 sm:px-4 lg:px-6">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex-shrink-0 cursor-pointer" onClick={() => navigate("/")}>
              <img
                src="/assets/Transparent background.png"
                alt="Ducktail"
                className="h-16 sm:h-18 lg:h-20"
              />
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex space-x-3 items-center">
              <a
                href=" "
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/");
                }}
                className="relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-300 text-white"
              >
                HOME
              </a>
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  const servicesSection = document.querySelector("#services");
                  if (servicesSection) {
                    const yOffset = servicesSection.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: yOffset, behavior: 'smooth' });
                  }
                }}
                className="relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-300 text-white"
              >
                SERVICES
              </a>
              
              {/* JOIN US Dropdown */}
              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={toggleDropdown}
                  className="relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-300 text-white"
                >
                  JOIN US
                </button>
                {isDropdownOpen && (
                  <div className="absolute left-0 mt-2 bg-gray-100 rounded shadow-lg">
                    <button
                      onClick={() => handleLoginRedirect("builder")}
                      className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                    >
                      Builder
                    </button>
                    <button
                      onClick={() => handleLoginRedirect("customer")}
                      className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                    >
                      Customer
                    </button>
                  </div>
                )}
              </div>
              
              {/* <a
                href=" "
                className="relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-300 text-white"
              >
                JOB PORTAL
              </a> */}
              <a
                href=" "
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/support");
                }}
                className="relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-300 text-white"
              >
                SUPPORT
              </a>

              {/* Login Button */}
              <div ref={loginDropdownRef}>
                <button
                  onClick={loginToggle}
                  className="bg-blue-600 text-white font-bold px-6 py-2 rounded-full hover:bg-blue-700"
                  style={{ marginLeft: "60px" }}
                >
                  Login 
                </button>
                {loginDropdownOpen && (
                  <div className="absolute mt-2 bg-gray-100 rounded shadow-lg">
                    <button
                      onClick={() => handleLoginRedirect("builder")}
                      className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                    >
                      Builder
                    </button>
                    <button
                      onClick={() => handleLoginRedirect("customer")}
                      className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                    >
                      Customer
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-white p-2 focus:outline-none"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {isOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>

              {/* Mobile Menu */}
              {isOpen && (
                <div className="absolute top-16 left-0 right-0 bg-white shadow-lg rounded-b-lg">
                  <div className="px-2 pt-2 pb-3 space-y-1">
                    <a
                      href=" "
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/");
                        setIsOpen(false);
                      }}
                      className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                    >
                      HOME
                    </a>
                    <a
                      href="#services"
                      onClick={(e) => {
                        e.preventDefault();
                        const servicesSection = document.querySelector("#services");
                        if (servicesSection) {
                          const yOffset = servicesSection.getBoundingClientRect().top + window.pageYOffset - 100;
                          window.scrollTo({ top: yOffset, behavior: 'smooth' });
                        }
                        setIsOpen(false);
                      }}
                      className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                    >
                      SERVICES
                    </a>
                    
                    {/* JOIN US Dropdown for Mobile */}
                    <div className="relative">
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setMobileJoinDropdown(!mobileJoinDropdown);
                          setMobileLoginDropdown(false);
                        }}
                        className="flex justify-between items-center w-full px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                      >
                        JOIN US
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      {mobileJoinDropdown && (
                        <div className="pl-4">
                          <button
                            onClick={() => handleLoginRedirect("builder")}
                            className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                          >
                            Builder
                          </button>
                          <button
                            onClick={() => handleLoginRedirect("customer")}
                            className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                          >
                            Customer
                          </button>
                        </div>
                      )}
                    </div>
                    
                    {/* <a
                      href=" "
                      className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                    >
                      JOB PORTAL
                    </a> */}
                    <a
                      href=" "
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/support");
                        setIsOpen(false);
                      }}
                      className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                    >
                      SUPPORT
                    </a>
                    
                    {/* LOGIN Dropdown for Mobile */}
                    <div className="relative">
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setMobileLoginDropdown(!mobileLoginDropdown);
                          setMobileJoinDropdown(false);
                        }}
                        className="flex justify-between items-center w-full px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                      >
                        LOGIN
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      {mobileLoginDropdown && (
                        <div className="pl-4">
                          <button
                            onClick={() => handleLoginRedirect("builder")}
                            className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                          >
                            Builder
                          </button>
                          <button
                            onClick={() => handleLoginRedirect("customer")}
                            className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                          >
                            Customer
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
      {/* Rest of your banner content */}
      <div
        style={{ height: "400px" }}
      >
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover"
          style={{ 
            backgroundImage: "url('/assets/Ducktail-Banner.jpg')",
            width: "1919px",
            maxWidth: "100%",
            margin: "0 auto"
          }}
        >
          <div className="absolute inset-0 bg-black opacity-55"></div>
        </div>
        
        {/* Content */}
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center text-white w-full max-w-5xl mx-auto px-4 pt-8">
          <h1
            className="font-bold mb-1"
            style={{
              fontSize: window.innerWidth < 768 ? "22px" : "36px",
              marginTop: "-20px"
            }}
          >
            DUCKTAIL – The Construction Platform
          </h1>
          <p className="text-sm md:text-base mb-1">
            Connecting you with Verified and Qualified Builders - Ensuring
            Trust, Quality, and Seamless Construction Experience
          </p>
          <p className="text-sm md:text-base mb-2">
            Now, it's easier than ever to find qualified and certified
            builders near you with Ducktail
          </p>
        </div>
      </div>
    </div>
      
      {/* Location Selection Form - Half Outside Banner */}
      <div className="relative z-20 -mt-20 mb-4">
        <div className="bg-white p-4 sm:p-6 rounded-xl shadow-lg max-w-4xl mx-auto border border-gray-200">
          <h2 className="text-base font-bold text-center mb-1 text-gray-800">
            Simplifying Your Building Journey
          </h2>
          <p className="text-center text-gray-600 mb-[0.90rem] text-xs">
            Connecting Dreams with Certified Builders!
          </p>
          
          {/* Dropdowns */}
          {/* <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <div className="w-full sm:w-1/3">
              <input
                type="text"
                className="w-full border px-3 py-2 rounded-md text-gray-800 text-sm text-center"
                value={selectedState || "Tamil Nadu"}
                readOnly
              />
            </div>

            <div className="w-full sm:w-1/3">
              <select
                className="w-full border px-3 py-2 rounded-md text-gray-800 text-sm"
                value={selectedDistrict}
                onChange={(e) => setLocalDistrict(e.target.value)}
                disabled={!selectedState}
              >
                <option value="">Select District</option>
                {districts.map((district) => (
                  <option key={district} value={district}>
                    {district}
                  </option>
                ))}
              </select>
            </div>

            <div className="w-full sm:w-1/3">
              <select
                className="w-full border px-3 py-2 rounded-md text-gray-800 text-sm"
                value={selectedTaluk}
                onChange={(e) => setLocalTaluk(e.target.value)}
                disabled={!selectedDistrict}
              >
                <option value="">Select Taluk</option>
                {taluks.map((taluk) => (
                  <option key={taluk} value={taluk}>
                    {taluk}
                  </option>
                ))}
              </select>
            </div>
          </div> */}
           <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <div className="flex w-full sm:w-2/3 gap-3">
            
              <div className="w-1/2">
                <select
                  className="w-full border px-3 py-2 rounded-md text-gray-800 text-sm"
                  value={selectedDistrict}
                  onChange={(e) => setLocalDistrict(e.target.value)}
                  disabled={!selectedState}
                >
                  <option value="">Select District</option>
                  {districts.map((district) => (
                    <option key={district} value={district}>
                      {district}
                    </option>
                  ))}
                </select>
              </div>

              <div className="w-1/2">
                <select
                  className="w-full border px-3 py-2 rounded-md text-gray-800 text-sm"
                  value={selectedTaluk}
                  onChange={(e) => setLocalTaluk(e.target.value)}
                  disabled={!selectedDistrict}
                >
                  <option value="">Select Taluk</option>
                  {taluks.map((taluk) => (
                    <option key={taluk} value={taluk}>
                      {taluk}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <button
              className="w-[158px] px-5 py-2 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 text-sm"
              onClick={handleFind}
            >
              FIND BUILDERS
            </button>
          </div>

          {/* <div className="mt-3 text-center">
            <button
              className="px-5 py-2 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 text-sm"
              onClick={handleFind}
            >
              FIND BUILDERS
            </button>
          </div> */}
        </div>
      </div>
      {/* Next Section */}
      <div className="py-3  flex justify-center">
        <div className="border border-gray-300 shadow-lg p-2 rounded-lg bg-white max-w-6xl text-center">
          <p className="text-gray-700 text-lg">
            Build your dream project with ease and confidence – Ducktail
            connects you to verified builders, guarantees quality with a 10-year
            warranty, and ensures a seamless construction experience.
          </p>
          <p className="font-normal text-xl">
            To avail the full benefits of DUCKTAIL –{" "}
            <span>
              <a
                href=" "
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/login?type=customer");
                }}
                className="text-blue-600 font-bold text-[18px] underline mt-2 inline-block"
              >
                SIGN UP FOR FREE
              </a>
            </span>
          </p>
        </div>
      </div>

      {/* Social Icons */}
      <div className="fixed right-2 top-1/2 transform -translate-y-1/2 space-y-2 z-50">
        {[
          {
            icon: faFacebookF,
            href: "https://www.facebook.com",
            color: "bg-blue-600",
            name: "Facebook",
          },
          {
            icon: faInstagram,
            href: "https://www.instagram.com",
            color: "bg-pink-600",
            name: "Instagram",
          },
          {
            icon: faLinkedin,
            href: "https://www.linkedin.com",
            color: "bg-blue-500",
            name: "Linkedin",
          },
        ].map((item, index) => (
          <div
            key={index}
            className="relative group flex items-center justify-end"
          >
            {/* Text (Appears on hover) */}
            <span
              className={`absolute right-14 top-0 h-full flex items-center px-3 rounded-md text-white ${item.color} 
      opacity-0 transform -translate-x-full group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-300 ease-in-out`}
            >
              {item.name}
            </span>

            {/* Icon */}
            <a
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`${item.color} w-11 h-11 flex items-center justify-center text-white rounded-full shadow-lg transition`}
            >
              <FontAwesomeIcon icon={item.icon} className="w-6 h-6" />
            </a>
          </div>
        ))}
      </div>

<section id="services" className="py-6">
  <div className="container max-w-6xl mx-auto px-4">
    <h2 className="text-2xl font-bold text-center text-blue-600 mb-6">
      DUCKTAIL'S OTHER SERVICES
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-20 py-5">
      {[
        // {
        //   title: "Home Loan",
        //   img: "/assets/Home-Loan.jpg",
        //   link: "/homeloan",
        //   comingSoon: false,
        // },
        {
          title: "Archi - Design",
          img: "/assets/art-design.jpg",
          link: "/archidesign",
          comingSoon: false,
        },
        {
          title: "Customer Support",
          img: "/assets/Customer-Support.jpg",
          link: "/support",
          comingSoon: false,
        },
        // {
        //   title: "Housing Plots",
        //   img: "/assets/Untitled-design-36.jpg",
        //   comingSoon: true,
        // },
        {
          title: "Construction Consultation",
          img: "/assets/Consulting.png",
          link: "/constructionconsultation",
          comingSoon: false,
        },
        {
          title: "Landscaping",
          img: "/assets/450.jpg",
          link: "/landscaping",
          comingSoon: false,
        },
        {
          title: "Commercial Construction",
          img: "/assets/2964.jpg",
          link: "/premiumconstruction",
          comingSoon: false,
        },
        // {
        //   title: "Interior Designers",
        //   img: "/assets/Interior-Design.png",
        //   comingSoon: true,
        // },
      ].map((service, index) => (
        <Link to={service.link || "#"} key={index} className="group h-full">
          <div className="bg-white rounded-2xl hover:shadow-lg transition-shadow duration-300 overflow-hidden text-center cursor-pointer border flex flex-col h-full relative">
            {service.comingSoon && (
              <div className="absolute top-0 left-0 bg-blue-500 text-white px-2 py-1 text-xs z-10 rounded-tl-2xl">
                Coming Soon
              </div>
            )}
            <div className="overflow-hidden">
              <img
                src={service.img}
                alt={service.title}
                className="w-full h-40 object-cover transform transition duration-300 group-hover:scale-110"
              />
            </div>
            <div className="p-4 flex-grow flex flex-col items-center justify-center text-center">
              <h3 className="font-medium text-base">{service.title}</h3>
            </div>
          </div>
        </Link>
      ))}
    </div>
  </div>
</section>



      {/* tile 1 */}
      <section className="relative py-4 flex justify-center">
        <div
          className="relative max-w-6xl w-full rounded-lg overflow-hidden"
          style={{
            backgroundImage: `url('/assets/Ducktail-home-loan.jpg')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            zIndex: -1,
          }}
        >
          {/* Overlay */}
          <div
            className="absolute inset-0"
            style={{
              backgroundColor: "#ffaf53", // Yellow overlay color from the image
              opacity: 0.5, // Adjust for desired transparency
              zIndex: 1,
            }}
          ></div>

          <div
            className="relative container mx-auto px-6 sm:px-12 lg:px-12"
            style={{ zIndex: 2 }}
          >
            <div className="flex flex-col lg:flex-row items-center justify-between py-8">
              {/* Text Content */}
              <div className="text-left max-w-[28rem] lg:max-w-[42rem]">
                <h2 className="text-2xl sm:text-3xl font-bold text-black mb-3">
                  Turn Your Dream Home into Reality 
                  {/* with Our Easy Home Loans! */}
                </h2>
              </div>

              {/* Button */}
              <div className="mt-4 lg:mt-0">
                {/* <a
                  href=" "
                  className="inline-block bg-blue-600 text-white font-semibold text-xs sm:text-sm py-2 px-5 rounded-full shadow-lg hover:bg-blue-700 transition duration-300"
                >
                  APPLY NOW
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* service 2 */}
      <section className="py-5">
        <div className="container max-w-5xl mx-auto px-3">
          <h2 className="text-xl font-bold text-center text-blue-600 mb-4">
            WHY CHOOSE DUCKTAIL
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {[
              {
                title: "10 Years Warranty",
                img: "/assets/Ducktail-10-years-warrenty-1 (1).png",
              },
              {
                title: "Verified Builders",
                img: "/assets/Ducktail-verified-builders.png",
              },
              {
                title: "Customer Support",
                img: "/assets/Support-service.png",
              },
              {
                title: "Organized System",
                img: "/assets/organised-service.png",
              },
              // {
              //   title: "Easy Home Loan",
              //   img: "/assets/Easy-home-loan.png",
              // },
              {
                title: "Customer Dashboard",
                img: "/assets/Customer-login.png",
                large: true,
              },
              {
                title: "One Stop Solution",
                img: "/assets/One-stop-solution.png",
              },
              {
                title: "Certified Builders",
                img: "/assets/Certified-builders.png",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-md shadow-sm p-3 text-center hover:shadow-md transition-shadow duration-200 relative"
              >
                {index === 0 && (
                  <span className="absolute top-1 right-1 text-[10px] text-black">*T&C Apply</span>
                )}
                <div className="overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className={`mx-auto mb-1 transform transition-transform duration-200 hover:scale-105 ${
                      item.large ? "w-16 h-14" : "w-14 h-14"
                    }`}
                  />
                </div>
                <h3 className="text-xs font-medium">{item.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* tile 2 */}
      <section className="relative py-12 flex justify-center">
        <div
          className="relative max-w-6xl w-full rounded-lg overflow-hidden"
          style={{
            backgroundImage: `url('/assets/Ducktail-clients.jpg')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            zIndex: -1,
          }}
        >
          {/* Overlay */}
          <div
            className="absolute inset-0"
            style={{
              backgroundColor: "#a1a09f", // Yellow overlay color from the image
              opacity: 0.5, // Adjust for desired transparency
              zIndex: 1,
            }}
          ></div>

          <div
            className="relative container mx-auto px-6 sm:px-12 lg:px-12"
            style={{ zIndex: 2 }}
          >
            <div className="flex flex-col lg:flex-row items-center justify-between py-8">
              {/* Text Content */}
              <div className="text-left max-w-md lg:max-w-lg">
                <h2 className="text-xl sm:text-2xl font-bold text-black mb-3">
                  Get into the world of clients
                </h2>
                <h2 className="text-xl sm:text-2xl font-bold text-black mb-3">
                  Register Your Construction Company
                </h2>
              </div>

              {/* Button */}
              {/* <div className="mt-4 lg:mt-0">
                <a
                  href=" "
                  className="inline-block bg-blue-600 text-white font-semibold text-xs py-2 px-5 rounded-full shadow-lg hover:bg-blue-700 transition duration-300"
                >
                  APPLY NOW
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* projects */}
      <section className=" py-1">
        <div className="container max-w-6xl mx-auto text-center ">
          <h2 className="text-3xl font-bold text-blue-700 mb-8">
            LATEST PROJECTS
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 ">
            {/* Render images */}
            {images.map((image, index) => (
              <div
                key={image.id}
                className={`relative group ${image.colSpan} transition-all duration-500`}
              >
                {/* Image */}
                <img
                  src={image.src}
                  alt={`Project ${index + 1}`}
                  className="rounded-lg shadow-md w-full h-full object-cover"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-500"></div>

                {/* "+" Button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <button
                    className="opacity-0 group-hover:opacity-100 translate-y-[-100%] group-hover:translate-y-0 transition-all duration-500 w-12 h-12 rounded-full border-2 border-white  text-white text-2xl flex items-center justify-center"
                    onClick={() => setSelectedImage(image.src)}
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal for image preview */}
        {selectedImage && (
          <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
            <div className="relative  rounded-lg p-10">
              <button
                className="absolute top-1 right-1 text-white text-3xl font-bold "
                onClick={() => setSelectedImage(null)}
              >
                &times;
              </button>
              <img
                src={selectedImage}
                alt="Selected Project"
                className="rounded-lg max-w-full max-h-[80vh] object-contain"
              />
            </div>
          </div>
        )}
      </section>

      {/* tile 3 */}
      <section className="relative py-14 flex justify-center">
        <div
          className="relative  w-full  overflow-hidden"
          style={{
            backgroundImage: `url('/assets/ducktails-job.jpg')`,
            backgroundSize: "cover",
            backgroundPosition: "top",
            backgroundRepeat: "no-repeat",

            zIndex: -1,
          }}
        >
          {/* Overlay */}
          <div
            className="absolute inset-0"
            style={{
              backgroundColor: "#232322c7", // Yellow overlay color from the image
              opacity: 0.5, // Adjust for desired transparency
              zIndex: 1,
            }}
          ></div>

          <div
            className="relative container max-w-6xl mx-auto px-6 sm:px-12 lg:px-12"
            style={{ zIndex: 2 }}
          >
            <div className="flex flex-col  py-16">
              {/* Text Content */}
              <div className="text-left max-w-md  lg:max-w-lg">
                <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8">
                  Finding your dream job is now easier with Ducktail!
                </h2>
              </div>

              {/* Button */}
              {/* <div className="mt-6 lg:mt-0">
                <a
                  href=" "
                  className="inline-block bg-blue-600 text-white font-semibold text-xs sm:text-sm py-3 px-6 rounded-full shadow-lg hover:bg-blue-700 transition duration-300"
                >
                  APPLY NOW
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* testimonal */}
      <section className="py-0 pb-[35px]">
        <div className="container max-w-6xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-8">
            OUR TESTIMONIALS
          </h2>
          <Swiper
            modules={[Autoplay]}
            autoplay={{ 
              delay: 3000,
              disableOnInteraction: true,
              pauseOnMouseEnter: true
            }}
            loop={true}
            slidesPerGroup={3}
            slidesPerView={3}
            spaceBetween={20}
            breakpoints={{
              320: {
                slidesPerView: 1,
                slidesPerGroup: 1
              },
              768: {
                slidesPerView: 2,
                slidesPerGroup: 2
              },
              1024: {
                slidesPerView: 3,
                slidesPerGroup: 3
              }
            }}
            className="w-full py-8"
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="bg-gray-100 rounded-lg shadow-lg p-4 mx-2 h-[200px] flex flex-col justify-between">
                  <div className="overflow-y-auto flex-grow">
                    <p className="text-sm text-gray-700 italic mb-2">
                      {testimonial.text}
                    </p>
                  </div>
                  <div className="mt-auto">
                    <div className="flex justify-center mb-2">
                      {Array.from({ length: testimonial.rating }, (_, i) => (
                        <svg
                          key={i}
                          className="w-4 h-4 text-orange-500"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M10 15l-5.09 3.26 1.93-6.36-5.09-3.74h6.3L10 2.5 12.95 8.16h6.3l-5.09 3.74 1.93 6.36z" />
                        </svg>
                      ))}
                    </div>
                    <h4 className="text-sm font-semibold text-gray-800">
                      {testimonial.name}
                    </h4>
                    <p className="text-xs text-gray-600">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="py-12 bg-gray-50">
        <div className="container max-w-6xl mx-auto">
          <h1 className="text-3xl font-bold text-center mb-12 text-gray-800">Pricing</h1>
          <div className="flex flex-col md:flex-row justify-center gap-8 mb-12 px-4">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full md:w-72 hover:transform hover:scale-105 transition duration-300">
              <h3 className="text-xl font-bold text-center mb-4 text-gray-800">Basic</h3>
              <p className="text-center text-gray-600 mb-4">Register before June</p>
              <p className="text-4xl font-bold text-center text-blue-600 mb-6">₹7,000</p>
              <div className="border-t border-gray-200 pt-4">
                <p className="text-center text-gray-600">Full access to platform</p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-6 w-full md:w-72 hover:transform hover:scale-105 transition duration-300">
              <h3 className="text-xl font-bold text-center mb-4 text-gray-800">Standard</h3>
              <p className="text-center text-gray-600 mb-4">Register before July</p>
              <p className="text-4xl font-bold text-center text-blue-600 mb-6">₹8,000</p>
              <div className="border-t border-gray-200 pt-4">
                <p className="text-center text-gray-600">Full access to platform</p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-6 w-full md:w-72 hover:transform hover:scale-105 transition duration-300">
              <h3 className="text-xl font-bold text-center mb-4 text-gray-800">Premium</h3>
              <p className="text-center text-gray-600 mb-4">After July</p>
              <p className="text-4xl font-bold text-center text-blue-600 mb-6">₹33,000</p>
              <div className="border-t border-gray-200 pt-4">
                <p className="text-center text-gray-600">Full access to platform</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footerlanding />
    </div>
  );
};

export default Homepage;
